<template>
    <div>
        <h4 v-if="title">
            {{ title }}
        </h4>
        <apexchart
            :height="height"
            :type="type"
            :options="options"
            :series="series"
        />
        <div v-if="isLoading || !series.length" class="loader-box">
            <div v-if="isLoading" class="loader">
                <div />
                <div />
                <div />
            </div>

            <div v-else>
                No data available
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        series: {
            type: Array,
            required: true,
            default: () => []
        },
        options: {
            type: Object,
            required: true,
            default: () => ({})
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        height: {
            type: String,
            required: false,
            default: '300'
        },
        type: {
            type: String,
            required: false,
            default: 'pie'
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
